import { useAuthStore } from './auth'

export interface ResolvedPermission {
  resource: string
  action: string
  allowedFields: string[]
}

export function usePermissions() {
  const permissions = useAuthStore((s) => s.permissions)

  function can(resource: string, action: string): boolean {
    return permissions.some(
      (p) => p.resource === resource && p.action === action,
    )
  }

  return { permissions, can }
}
